import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const fetchZendeskToken = async () => {
  const data = await fetchWithAuthorization({ path: END_POINTS.ZENDESK_VERIFY, method: 'GET' })
  return data
}
